/*
 *   File : custom-picker.js
 *   Author : https://evoqins.com
 *   Description : Custom range picker
 *   Integrations : react-data-table-component
 *   Version : 1.0.0
 */
/*import packages*/
import { Fragment } from "react"

/*import components*/
import Icon from "../Icon/icon";
import { DateRangeFilterPopup } from "../Popups";


const CustomDateRangePicker = (props) => {
    return (
        <Fragment>
            <p className={`${props.className} border-radius-6px border-all border-bright-gray bg-white p-2 mb-0 color-outer-space e-poppins-regular e-font-14 line-height-24px cursor-pointer d-flex justify-content-between align-items-center mt-0`}
                onClick={props.handleShowDateFilter}>


                {props.startDate === null && props.endDate === null
                    ? props.placeholder
                    : `${props.startDate !== null ? props.startDate : ''}${props.endDate !== null ? ' - ' + props.endDate : ''}`}



                <Icon icon="calendar1"
                    width="24px"
                    height="24px"
                    className="ms-2" />
            </p>
            {
                props.showDateFilter === true &&
                <div ref={props.popupRef}>
                    <DateRangeFilterPopup
                        leftAlign={true}
                        maxDate={new Date()}
                        leftOffset={props.leftOffset}
                        initialRange={props.selectedRange}
                        cancel={() => {
                            props.handleShowDateFilter();
                            props.clearDates();
                        }}
                        onUpdate={props.handleDateRangeChange} />
                </div>
            }

            {props.error && (
                <div className='position-absolute d-flex align-items-center mt-1'>
                    <Icon
                        icon="info-circle"
                        size={16}
                        className="me-1"
                    />
                    <p className='color-red mb-0 e-font-12'>
                        {props.error}
                    </p>
                </div>
            )}
        </Fragment>
    )
}

CustomDateRangePicker.defaultProps = {
    handleDateRangeChange: () => { },
    selectedRange: [],
    startDate: null,
    endDate: null,
    handleShowDateFilter: () => { },
    popupRef: null,
    placeholder: "Start Date - End Date"
}

export default CustomDateRangePicker;